import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import HomePage from './components/HomePage';
import AuthPage from './components/AuthPage';
import SkinTable from './components/SkinTable';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/signin" element={<AuthPage />} />
        {/* Nothing stands between signing in and the tracker. Connecting a
            Steam account is a button in the Inventory tab, not a checkpoint:
            plenty of the app is useful before anyone links anything, and
            SkinTable already sends a request without a session back to
            /signin, so a dead token cannot get past here either. */}
        <Route path="/app" element={<SkinTable />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
